/**
 * Identity
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DateTimePeriod } from './date-time-period';

export interface UpdatePermissionGrantRequest {
  id: string;
  grantDates?: DateTimePeriod;
  permissionIds: Array<string>;
}
